var React = require('react');

function RightArrowInline (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M0,90.19L9.72,100l59.9-50.01L9.7,0L0,9.88l48.58,39.94L0,90.19z"})));
}

RightArrowInline.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 69.62 100","style":{"enableBackground":"new 0 0 69.62 100"},"xmlSpace":"preserve"};

module.exports = RightArrowInline;

RightArrowInline.default = RightArrowInline;
